<template>
	<el-form-item label="高度">
		<el-input-number v-model="data.options.height" :min="200" />
	</el-form-item>

	<el-form-item label="默认值">
		<el-input v-model="data.options.defaultValue" type="textarea" />
	</el-form-item>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'

export default defineComponent({
	name: 'ItemEditor',
	props: {
		active: {
			type: Object,
			default: null
		}
	},
	emits: ['update:active'],
	setup(props, context) {
		const data = ref(props.active)
		watch(data, val => context.emit('update:active', val), { deep: true })

		return {
			data
		}
	}
})
</script>
